<template>
  <split-times
    v-if="showSplitTimes"
    class="split-times"
    :split-times="splitTimeState.splitTimes"
    :penalty="penalty"
  />
</template>

<script lang="ts">
import { SplitTimes } from '@powerplay/core-minigames-ui'
import { defineComponent } from 'vue'
import { modes } from '@powerplay/core-minigames'
import {
  splitTimeState,
  timeState
} from '@/stores'

export default defineComponent({
  name: 'MiddletimesDownhill',
  components: {
    SplitTimes
  },
  data() {

    return {
      splitTimeState: splitTimeState()
    }

  },
  computed: {
    showSplitTimes() {

      return !modes.isTutorial()

    },
    penalty() {

      return timeState().penaltySeconds > 0 ?
        String(timeState().penaltySeconds) :
        ''

    }
  }
})
</script>

<style scoped lang="less">
.split-times {
  position: absolute;
  transform-origin: top left;
  left: 16px;
  top: 17%;
}
</style>
